export const faqData = [
  {
    id: "booking",
    question: "How do I book a trip or tour?",
    answer:
      "Browse our Destinations or Recommended trips, choose one that fits you, then contact us via the Contact page, phone, WhatsApp, or email. We'll confirm availability, discuss your preferences and dates, and send you a tailored quote. Once you're happy, we'll guide you through the booking and payment process.",
  },
  {
    id: "included",
    question: "What's included in your travel packages?",
    answer:
      "It varies by trip, but typically our packages include accommodation (teahouse or camping as relevant), experienced guides, permits and park fees, ground transport as per the itinerary, and sometimes meals. Each destination page and trip detail shows exactly what's included and what's not. We're happy to clarify before you book.",
  },
  {
    id: "payment",
    question: "How can I pay?",
    answer:
      "We accept bank transfer and other methods as agreed. You'll usually pay a deposit to confirm your booking and the balance before or during your trip. We'll send clear payment instructions and receipts. Contact us for the options available for your booking.",
  },
  {
    id: "cancellation",
    question: "What is your cancellation policy?",
    answer:
      "Cancellation terms depend on the trip and how close to the departure date you cancel. We'll explain the policy when you book. We recommend travel insurance that covers cancellation so you're protected if plans change. Ask us for details when you enquire.",
  },
  {
    id: "visa",
    question: "Do you help with visas and immigration?",
    answer:
      "Yes. We offer immigration assistance including visa advice, documentation, and relocation support. See our Services page and select Immigration Assistance for more. For Nepal entry, we can advise on visa-on-arrival and requirements; for other countries, our immigration team can guide you.",
  },
  {
    id: "insurance",
    question: "Do you offer travel insurance?",
    answer:
      "Yes. We offer travel insurance suitable for trips and adventure activities, including coverage for medical emergencies, trip cancellation, and lost luggage. See our Services page and select Travel Insurance for plans and options. We can help you choose the right cover for your journey.",
  },
  {
    id: "contact",
    question: "How do I get in touch?",
    answer:
      "Use our Contact page to send a message, or reach us by phone, WhatsApp, or email (all listed in the footer and on the Contact page). We aim to reply quickly. For urgent enquiries, WhatsApp or phone is often the fastest.",
  },
];
